import { lazy, PureComponent, Suspense } from 'react';

import Helmet from 'react-helmet'
import { type RouteComponentProps } from 'react-router'

export const SETTINGS_IMPORT_URL = '/settings/import'

const SettingsImportChunk = lazy(() =>
  import('../containers/SettingsImport').then(
    ({ ConnectedSettingsImport }) => ({
      default: ConnectedSettingsImport,
    })
  )
)

export class SettingsImportPage extends PureComponent<RouteComponentProps> {
  render() {
    return (
      <>
        <Helmet>
          <title>Procurify | Settings Import</title>
        </Helmet>
        <Suspense fallback={null}>
          <SettingsImportChunk {...this.props} />
        </Suspense>
      </>
    );
  }
}
